import React, { useState, useContext } from "react";
import { Link } from "@reach/router";
import { AuthContext } from "../../context/AuthContext";
import { ModalContext } from "../../context/ModalContext";
import { validateEmail, validatePhoneNumber } from "../../utils";

const SignUpForm = ({ signInAction, handleCallback }) => {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [otro, setOtro] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [telefono, setTelefono] = useState("");

  const { spinner, signUp } = useContext(AuthContext);

  const { alert } = useContext(ModalContext);

  const renderOtro = () => {
    if (reason === "Otro") {
      return (
        <div>
          <label>Cuéntanos cómo te enteraste</label>
          <input
            type="text"
            className="form-control mb-3"
            value={otro}
            onChange={(e) => setOtro(e.target.value)}
          />
        </div>
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (nombre === "") {
      return alert("Debes ingresar tu nombre.");
    }
    if (apellidos === "") {
      return alert("Debes ingresar tus apellidos.");
    }
    if (!validateEmail(email)) {
      return alert("El correo electrónico no es válido.");
    }
    if (String(password).length < 6) {
      return alert("La contraseña debe tener al menos 6 caracteres.");
    }
    if (!validatePhoneNumber(telefono)) {
      return alert("Debes ingresar un número de teléfono válido.");
    }
    if (password !== passwordConfirm) {
      return alert("Las contraseñas no coinciden");
    }
    if ((reason === "Otro" && otro === "") || reason === "") {
      return alert("Debes completar el campo de cómo te enteraste de TBM");
    }
    signUp(
      nombre,
      apellidos,
      email,
      password,
      telefono,
      reason !== "Otro" ? reason : otro,
      handleCallback
    );
  };
  return (
    <>
      <div id="login-card" className="card no-scale text-left shadow p-4">
        <h1 className="h5">Regístrate</h1>
        <form onSubmit={handleSubmit}>
          <label>Nombre</label>
          <input
            type="text"
            className="form-control mb-3"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />
          <label>Apellidos</label>
          <input
            type="text"
            className="form-control mb-3"
            value={apellidos}
            onChange={(e) => setApellidos(e.target.value)}
          />
          <label>Correo Electrónico</label>
          <input
            type="email"
            className="form-control mb-3"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <label>Contraseña</label>
          <input
            type="password"
            className="form-control mb-3"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <label>Confirmar Contraseña</label>
          <input
            type="password"
            className="form-control mb-3"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
          />
          <label>Teléfono (WhatsApp)</label>
          <input
            type="tel"
            className="form-control mb-3"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
          />
          <label>¿Cómo te enteraste de TBM?</label>
          <select
            required  
            value={reason}
            className="form-control"
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="">Elige una opción</option>
            <option value="Instagram">Instagram</option>
            <option value="Recomendación">Recomendación</option>
            <option value="Ví el local">Ví el local</option>
            <option value="Ex Alumna">Ex Alumna</option>
            <option value="Otro">Otro</option>
          </select>
          <div className="mt-3">{renderOtro()}</div>
          <button type="submit" className="btn btn-primary" value="Entrar">
            {spinner ? <div className="spinner-border"></div> : "Regístrate"}
          </button>
        </form>
        <div className="container-fluid px-0 mt-4">
          ¿Ya tienes cuenta?{" "}
          {typeof signInAction === "function" ? (
            <button onClick={signInAction} className="btn btn-link text-accent">
              Inicia Sesión
            </button>
          ) : (
            <Link to="/entrar" className="text-accent">
              Inicia Sesión
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default SignUpForm;
